import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=57c270d6&"
import script from "./Discord.vue?vue&type=script&lang=js&"
export * from "./Discord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports